var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.9,50.9V29.3c2.4-0.8,4.2-3.1,4.2-5.8c0-3.4-2.8-6.2-6.2-6.2c-1.5,0-2.9,0.6-4,1.5L46.2,8c0.1-0.4,0.1-0.8,0.1-1.2 c0-3.4-2.8-6.2-6.2-6.2c-3.4,0-6.2,2.8-6.2,6.2c0,0.4,0,0.8,0.1,1.2L15.4,18.7c-1.1-1-2.6-1.6-4.1-1.6c-3.4,0-6.2,2.8-6.2,6.2 c0,2.7,1.7,5,4.2,5.8v21.6c-2.5,0.8-4.4,3.1-4.4,5.9c0,3.4,2.8,6.2,6.2,6.2c1.6,0,3-0.6,4.1-1.6L34,72.2c-0.1,0.3-0.1,0.7-0.1,1 c0,3.4,2.8,6.2,6.2,6.2s6.2-2.8,6.2-6.2c0-0.4,0-0.7-0.1-1l18.7-10.8c1.1,1,2.5,1.6,4.1,1.6c3.4,0,6.2-2.8,6.2-6.2 C75.2,54.1,73.4,51.7,70.9,50.9z M38,67.4c-0.8,0.3-1.5,0.7-2,1.2L17.1,57.7c0.1-0.3,0.1-0.7,0.1-1c0-2.6-1.6-4.8-3.9-5.7V29.1 c2.4-0.9,4.1-3.1,4.1-5.8c0-0.3,0-0.6-0.1-1l18.8-10.8c0.6,0.5,1.2,0.9,1.9,1.1V67.4z M42.1,12.6c0.7-0.2,1.4-0.6,1.9-1.1 l18.8,10.9c-0.1,0.4-0.1,0.7-0.1,1.1c0,0.3,0,0.6,0.1,0.9L42.1,36.5V12.6z M62.9,57.8L44.1,68.6c-0.6-0.5-1.3-0.9-2-1.2V43.6 l20.8,12c-0.1,0.4-0.1,0.8-0.1,1.3C62.8,57.1,62.8,57.5,62.9,57.8z M66.8,51c-0.6,0.2-1.2,0.6-1.7,1h0L44.2,40l20.5-12 c0.6,0.5,1.3,1,2,1.2V51z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.72df8cdcb888c13a733195492c9ce477.svg";
export { ForwardRef as ReactComponent };